export type ServerError = {
  code?: string;
  description?: string;
};

/**
 * @param errorData The `errorData` of an ErrorPayload - the raw api response
 * @returns The first error found, or null when the body carries none
 */
export const getServerError = (errorData: any): ServerError | null => {
  const data = errorData?.data;

  if (!data) return null;

  const serverError: ServerError | undefined = Array.isArray(data) ? data[0] : data;

  if (!serverError?.code && !serverError?.description) return null;

  return serverError;
};

// TODO remove this temporary approach for error handling when there is proper server error handling.
export const checkErrorSatusCode = (
  statusCode: number,
  clientErrorMessage: string,
  serverErrorMessage: string,
): string => {
  if (statusCode >= 400 && statusCode < 500) return clientErrorMessage;
  if (statusCode >= 500) return serverErrorMessage;
  return '';
};

export function appendToErrorsLog(message: string, state: { errorsLog: string[] } | null, errorsLog?: string[]) {
  const theLogs = state?.errorsLog ?? errorsLog;
  if (!theLogs) return;

  theLogs.push(`${message}@@${new Date().toISOString()}`);
  if (theLogs.length > 15) theLogs.shift();
}
